import { i18n } from 'i18n';

export default function translatedMessage(id) {
  return i18n._(id);
}
